import Vue from 'vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import DatetimeView from 'vux/src/components/datetime-view/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XCircle from 'vux/src/components/x-circle/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Popover from 'vux/src/components/popover/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'


Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)

Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.component('popup', Popup)
Vue.component('x-button', XButton)
Vue.component('x-switch', XSwitch)
Vue.component('popup-picker', PopupPicker)
Vue.component('picker', Picker)
Vue.component('datetime', Datetime)
Vue.component('scroller', Scroller)
Vue.component('datetime-view', DatetimeView)
Vue.component('actionsheet', Actionsheet)
Vue.component('confirm', Confirm)
Vue.component('loadMore', LoadMore)
Vue.component('swiper', Swiper)
Vue.component('swiper-item', SwiperItem)
Vue.component('x-circle', XCircle)
Vue.component('x-dialog', XDialog)
Vue.component('x-address', XAddress)
Vue.component('x-textarea', XTextarea)
Vue.component('divider', Divider)
Vue.component('popover', Popover)
Vue.component('checklist', Checklist)
Vue.component('xTable', XTable)



// WEBPACK FOOTER //
// ./src/common/ui/vux.js